import { render, staticRenderFns } from "./MemberMain.vue?vue&type=template&id=4596e48e&"
import script from "./MemberMain.vue?vue&type=script&lang=ts&"
export * from "./MemberMain.vue?vue&type=script&lang=ts&"
import style0 from "./MemberMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports